// An accountant invitation link (/accept-accountant-invite?token=...), kept through signing in or
// creating an account like a company invitation (invite.ts). Opening it leads to Practice Onboarding
// for someone with no practice yet, and accepting links the business to their practice (ADR 0044).

const KEY = 'mybooks.accountantInviteToken';
export const ACCOUNTANT_INVITE_PATH = '/accept-accountant-invite';
const TOKEN_RE = /^[A-Za-z0-9_-]{32,128}$/;

export function pendingAccountantInviteToken(location: Pick<Location, 'pathname' | 'search'> = window.location): string | null {
  if (location.pathname === ACCOUNTANT_INVITE_PATH) {
    const token = new URLSearchParams(location.search).get('token');
    if (token && TOKEN_RE.test(token)) {
      try { sessionStorage.setItem(KEY, token); } catch { /* storage blocked: the URL still has it */ }
      return token;
    }
  }
  try {
    const kept = sessionStorage.getItem(KEY);
    return kept && TOKEN_RE.test(kept) ? kept : null;
  } catch {
    return null;
  }
}

export function clearAccountantInviteToken() {
  try { sessionStorage.removeItem(KEY); } catch { /* ignore */ }
}
